const Project = () => import(/* webpackPrefetch: true */ '@/views/private/project/Index.vue')
const ProjectDetail = () => import(/* webpackPrefetch: true */ '@/views/private/project/ProjectDetail.vue')
const ProjectCreate = () => import(/* webpackPrefetch: true */ '@/views/private/project/ProjectCreate.vue')
const ProjectUpdate = () => import(/* webpackPrefetch: true */ '@/views/private/project/ProjectUpdate.vue')

const routes = [
  {
    path: "/project",
    name: "project",
    component: Project,
    meta: {
      title: "Proyek"
    }
  },
  {
    path: "/project/detail/:id",
    name: "project detail",
    component: ProjectDetail,
    meta: {
      title: "Proyek Detail"
    }
  },
  {
    path: "/project/create",
    name: "project create",
    component: ProjectCreate,
    meta: {
      title: "Tambah Proyek Baru"
    }
  },
  {
    path: "/project/update/:id",
    name: "project update",
    component: ProjectUpdate,
    meta: {
      title: "Ubah Proyek"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})